import { useEffect } from 'react';

function getSubdomain(): string {
  return window.location.host.split('.')[0];
}

export default function useSetFavicon() {
  useEffect(() => {
    function setFavicon(url: string) {
      document.querySelector<HTMLLinkElement>('link[rel="icon"]')!.href = url;
    }

    if (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'
    ) {
      setFavicon('/logo-dark-localhost128.png');
      return;
    }

    const subdomain = getSubdomain();

    if (subdomain === 'dev') {
      setFavicon('/logo-dark-dev128.png');
      return;
    }

    if (subdomain === 'deepdub') {
      setFavicon('/logo-dark-prod128.png');
    }
  }, []);
}
